export class User {
    id: string;
    email: string;
    password: string;
    nome: string;
    cognome: string;
    telefono: string;
    dataNascita: Date;
    provinciaNascita: string;
    comuneNascita: string;
    provinciaResidenza: string;
    comuneResidenza: string;
    capResidenza: string;
    indirizzoResidenza: string;
    defaultPasswordChanged: string;
}
